import { StarOutline } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const RatingFieldStaticConfig = {
  Icon: StarOutline,
  type: DatabaseFieldTypeEnum.Rating,
  labelKey: 'Database:DataTypes.Rating',
};
